import { render, staticRenderFns } from "./ApiAdressePlugin.vue?vue&type=template&id=022f7e82&scoped=true"
import script from "./ApiAdressePlugin.vue?vue&type=script&lang=ts"
export * from "./ApiAdressePlugin.vue?vue&type=script&lang=ts"
import style0 from "./ApiAdressePlugin.vue?vue&type=style&index=0&id=022f7e82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022f7e82",
  null
  
)

export default component.exports